// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__6zAxD","inner":"Styles_inner__d5rlH","dot":"Styles_dot__2sf6U","dotAnimation":"Styles_dotAnimation__3pvxg"};